import * as Yup from "yup";
import { States } from "../../../../../constants";
import { emailRegEx, zipCodeRegEx } from "utils/RegularExpressions";

export const validStateOptions: string[] = [];
States.forEach((state) => validStateOptions.push(state.name));

const defaultStepsSchema = Yup.object({
  applicantInformation: Yup.object({
    fullName: Yup.string()
      .required("Required")
      .max(250, "Must be less than 250 characters."),
    contactEmail: Yup.string()
      .required("Required")
      .matches(emailRegEx, "Please enter a valid email address"),
  }),
});

const step1Schema = Yup.object({
  step1: Yup.object({
    section1: Yup.object({
      bondBill: Yup.string().required("Required"),
      legislativeDistrict: Yup.string().required("Required"),
      chapterNumber: Yup.number()
        .required("Required")
        .typeError("Amount is required")
        .positive("It must be greater than 0")
        .integer("It must be integer")
        .transform((_, val) => (val ? Number(val) : undefined)),
      authorizedYear: Yup.date().required("Required").typeError("Invalid Date"),
      dgsItemNumber: Yup.number()
        .required("Required")
        .typeError("Amount is required")
        .positive("It must be greater than 0")
        .integer("It must be integer")
        .transform((_, val) => (val ? Number(val) : undefined)),
      projectTitle: Yup.string().required("Required"),
      streetAddress: Yup.string()
        .required("Street Address is required")
        .min(4, "Street Address must be greater than 4 character"),
      city: Yup.string()
        .required("City is required")
        .min(2, "City must be greater than 2 character"),
      state: Yup.string()
        .required("State is required")
        .oneOf(validStateOptions, "You must select a valid option"),
      zipCode: Yup.string()
        .required("Zip / Postal code is required")
        .matches(zipCodeRegEx, "Zip / Postal Code must be a 5 digit number")
        .max(5, "Zip / Postal Code must be 5 digits")
        .min(5, "Zip / Postal Code must be 5 digits"),
    }),
    section2: Yup.object({
      granteeOrganization: Yup.string().required("Required"),
      grantAmount: Yup.number()
        .required("Required")
        .typeError("Amount is required")
        .positive("It must be greater than 0")
        .integer("It must be integer")
        .transform((_, val) => (val ? Number(val) : undefined)),
      streetAddress: Yup.string()
        .required("Street Address is required")
        .min(4, "Street Address must be greater than 4 character"),
      city: Yup.string()
        .required("City is required")
        .min(2, "City must be greater than 2 character"),
      state: Yup.string()
        .required("State is required")
        .oneOf(validStateOptions, "You must select a valid option"),
      zipCode: Yup.string()
        .required("Zip / Postal code is required")
        .matches(zipCodeRegEx, "Zip / Postal Code must be a 5 digit number")
        .max(5, "Zip / Postal Code must be 5 digits")
        .min(5, "Zip / Postal Code must be 5 digits"),
      matchAmount: Yup.number()
        .required("Required")
        .typeError("Amount is required")
        .positive("It must be greater than 0")
        .integer("It must be integer")
        .transform((_, val) => (val ? Number(val) : undefined)),
    }),
    section3: Yup.object({
      isSoloOwner: Yup.boolean(),
      isCoOwner: Yup.boolean(),
      coOwnerName: Yup.string().when("isCoOwner", {
        is: true,
        then: (schema) => schema.required("Required"),
        otherwise: (schema) => schema.nullable(),
      }),
      hasLongTermLease: Yup.boolean(),
      leaseTerm: Yup.string().when("hasLongTermLease", {
        is: true,
        then: (schema) =>
          Yup.number()
            .required("Required")
            .typeError("Amount is required")
            .positive("It must be greater than 0")
            .integer("It must be integer")
            .transform((_, val) => (val ? Number(val) : undefined)),
        otherwise: (schema) => schema.nullable(),
      }),
      doesNotOwn: Yup.boolean(),
      ownerName: Yup.string().when("doesNotOwn", {
        is: true,
        then: (schema) => schema.required("Required"),
        otherwise: (schema) => schema.nullable(),
      }),
      ownerEmail: Yup.string().when("doesNotOwn", {
        is: true,
        then: (schema) => schema.required("Required"),
        otherwise: (schema) => schema.nullable(),
      }),
      ownerPhoneNumber: Yup.string().when("doesNotOwn", {
        is: true,
        then: (schema) => schema.required("Required"),
        otherwise: (schema) => schema.nullable(),
      }),
    }),
    section4: Yup.object({
      design: Yup.object({
        startDate: Yup.date().required("Required").typeError("Invalid Date"),
        finishDate: Yup.date().required("Required").typeError("Invalid Date"),
      }),
      construction: Yup.object({
        startDate: Yup.date().required("Required").typeError("Invalid Date"),
        finishDate: Yup.date().required("Required").typeError("Invalid Date"),
      }),
      description: Yup.string().required("Required"),
      requirePreservationEasement: Yup.string().required("Required"),
      utilizeMBEEnterprise: Yup.string().required("Required"),
    }),
  }),
});

const step2Schema = Yup.object({
  step2: Yup.object({
    estimatedProjectBudget: Yup.array(),
    q1: Yup.string().required("Required"),
    q2: Yup.string().required("Required"),
  }),
});

const step3Schema = Yup.object({
  step3: Yup.object({}),
});

const step4Schema = Yup.object({
  step4: Yup.object({}),
});

const step5Schema = Yup.object({
  step5: Yup.object({
    granteeName: Yup.string().required("Required"),
    authorizedRepresentative: Yup.string().required("Required"),
  }),
});
export const MDGSValidationSchema = [
  defaultStepsSchema,
  step1Schema,
  step2Schema,
  step3Schema,
  step4Schema,
  step5Schema,
];
